
import { AccrualsCompensationFor } from 'app/dataTypes/subsidy/settings'
import { controls } from './formParts/AccuralsForFormCompensation'


export function extractCompensationAccrualFor(formData: FormData): AccrualsCompensationFor {
  return {
    single: [
      !!formData.get(`${controls.single}1`),
      !!formData.get(`${controls.single}2`),
    ],
    class: [
      !!formData.get(`${controls.class}1`),
      !!formData.get(`${controls.class}2`),
    ],
  }
}
